module.exports = __webpack_public_path__ + "img/bg_judicial_03.950b086a.jpg";